<template>
  <b-container fluid>
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">{{homeTitleTop}}</div>
          <div class="title-middle text-uppercase primaryColor">{{homeTitleMid}}</div>
          <center>
            <div class="title-bottom">{{homeTitleBot}}</div>
          </center>
        </div>
      </b-col>
    </b-row>
    <!-- Service -->
    <b-row class="sections section1" :class="{section1Desktop: !isMobile}">
      <b-col lg="4" md="4" sm="12" xs="12" class="bcol">
        <div class="homeIcon">
          <img src="../assets/2.png" alt="We Sketch">
        </div>
        <div class="homeIconTitle" :class="{homeIconTitleDesktop: !isMobile}">
          Scaffolding Lebih Kokoh
        </div>
        <div class="homeIconDesc">
          Kami menyediakan scaffolding yang lebih kokoh untuk segala kebutuhan pembangunan dalam skala kecil maupun besar.
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" xs="12" class="bcol">
        <div class="homeIcon">
          <img src="../assets/sketch256.png" alt="We Sketch">
        </div>
        <div class="homeIconTitle" :class="{homeIconTitleDesktop: !isMobile}">
          Biaya Formwork Terencana
        </div>
        <div class="homeIconDesc">
          Perencanaan formwork dengan efisiensi tenaga kerja, biaya, dan waktu.
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" xs="12" class="bcol">
        <div class="homeIcon">
          <img src="../assets/hammer256.png" alt="We Sketch">
        </div>
        <div class="homeIconTitle" :class="{homeIconTitleDesktop: !isMobile}">
          Penggunaan Kayu & Paku Minimal
        </div>
        <div class="homeIconDesc">
          Sistem penyangga bekisting bangunan memenuhi kebutuhan konstruksi dengan penggunaan kayu & paku minimal.
        </div>
      </b-col>
    </b-row>
    <!-- Quote -->
    <b-row class="sections section2 text-left">
      <b-col lg="8" md="8" sm="12" xs="12" class="bcol">
        <div class="preTitle primaryColor">
          {{homeDynamicText1}}
        </div>
        <div class="title">
          {{homeDynamicText2}}
        </div>
        <div class="description">
          {{homeDynamicText3}}
        </div>
        <div>
          <button v-on:click="goToProducts()" class="goToProductsBtn primaryBtn">Lihat produk kami</button>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" xs="12" class="bcol quoteForm" v-bind:style="{background: 'url(' + getImage(quoteFormBg, 'banner') +')'}">
        <div class="formTitle">
          Hubungi Kami
        </div>
        <div class="form">
          <div v-if="false">
            <select v-model="selectedService">
              <option v-for="(service, index) in services" :value="service" :key="index">{{service}}</option>
            </select>
          </div>
          <div>
            <input type="text" v-model="inquiry.name" placeholder="Name">
          </div>
          <div>
            <input type="number" v-model="inquiry.phoneNumber" placeholder="Phone Number">
          </div>
          <div>
            <input type="email" v-model="inquiry.email" placeholder="Email">
          </div>
          <div>
            <button v-on:click="createInquiry()" class="primaryBtn">Kirim</button>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Numbers -->
    <b-row v-if="false" class="sections section3">
      <b-col lg="3" md="3" sm="3" xs="1" class="bcol">
        <center>
          <div class="anumber" v-observe-visibility="{callback: visibilityChanged1, once: true}">
            <animate-number
              ref="num1"
              :from="from"
              :to="until"
              mode="manual"
              duration="3000"
              easing="easeOutQuad"
              :animate-end="afterParty"
            ></animate-number>
            <!--from-color="#ec4949" to-color="#44CC00" -->
          </div>
          <div class="anumberText">Projects Completed</div>
        </center>
      </b-col>
      <b-col lg="3" md="3" sm="3" xs="1" class="bcol">
        <center>
          <div class="anumber" v-observe-visibility="{callback: visibilityChanged2, once: true}">
            <animate-number
              ref="num2"
              :from="from"
              :to="until"
              mode="manual"
              duration="3000"
              easing="easeOutQuad"
              :animate-end="afterParty"
            ></animate-number>
          </div>
          <div class="anumberText">Happy Clients</div>
        </center>
      </b-col>
      <b-col lg="3" md="3" sm="3" xs="1" class="bcol">
        <center>
          <div class="anumber" v-observe-visibility="{callback: visibilityChanged3, once: true}">
            <animate-number
              ref="num3"
              :from="from"
              :to="until"
              mode="manual"
              duration="3000"
              easing="easeOutQuad"
              :animate-end="afterParty"
            ></animate-number>
          </div>
          <div class="anumberText">Total Employees</div>
        </center>
      </b-col>
      <b-col lg="3" md="3" sm="3" xs="1" class="bcol">
        <center>
          <div class="anumber" v-observe-visibility="{callback: visibilityChanged4, once: true}">
            <animate-number
              ref="num4"
              :from="from"
              :to="until"
              mode="manual"
              duration="3000"
              easing="easeOutQuad"
              :animate-end="afterParty"
            ></animate-number>
          </div>
          <div class="anumberText">Ticket Submitted</div>
        </center>
      </b-col>
    </b-row>
    <!-- Our Latest Projects -->
    <b-row class="sections latestProjects p-5">
      <b-col lg="12" md="12" sm="12" xs="12">
        <div>
          <h3>Portofolio</h3>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="projectList != null && projectList.data != null && projectList.data.length > 0" class="sections sectionProject">
      <b-col lg="8" md="8" sm="12" xs="12" class="bcol project" @mouseover="p1Active = true" @mouseleave="p1Active = false">
        <img class="img" :src="getImage(projectList.data[0].attributes.images.data[0].attributes.url, 'url')">
        <div v-show="p1Active" class="centered">
          <h4>{{projectList.data[0].attributes.name}}</h4>
          <button v-on:click="goToProject()" class="goToProductsBtn primaryBtn">See all projects</button>
        </div>
      </b-col>
      <b-col v-if="projectList.data.length > 1" lg="4" md="4" sm="12" xs="12" class="bcol project" @mouseover="p2Active = true" @mouseleave="p2Active = false">
        <img class="img" :src="getImage(projectList.data[1].attributes.images.data[0].attributes.url, 'url')">
        <div v-show="p2Active" class="centered">
          <h4>{{projectList.data[1].attributes.name}}</h4>
          <button v-on:click="goToProject()" class="goToProductsBtn primaryBtn">See all projects</button>
        </div>
      </b-col>
      <b-col v-if="projectList.data.length > 2" lg="6" md="6" sm="12" xs="12" class="bcol project" @mouseover="p3Active = true" @mouseleave="p3Active = false">
        <img class="img" :src="getImage(projectList.data[2].attributes.images.data[0].attributes.url, 'url')">
        <div v-show="p3Active" class="centered">
          <h4>{{projectList.data[2].attributes.name}}</h4>
          <button v-on:click="goToProject()" class="goToProductsBtn primaryBtn">See all projects</button>
        </div>
      </b-col>
      <b-col v-if="projectList.data.length > 3" lg="6" md="6" sm="12" xs="12" class="bcol project" @mouseover="p4Active = true" @mouseleave="p4Active = false">
        <img class="img" :src="getImage(projectList.data[3].attributes.images.data[0].attributes.url, 'url')">
        <div v-show="p4Active" class="centered">
          <h4>{{projectList.data[3].attributes.name}}</h4>
          <button v-on:click="goToProject()" class="goToProductsBtn primaryBtn">See all projects</button>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Homepage',
  data () {
    return {
      bannerImg: 'dsk-home-bg.jpg',
      quoteFormBg: 'formBg.jpg',
      windowWidth: 0,
      windowHeight: 0,
      inquiry: {
        email: '',
        name: '',
        phoneNumber: '',
        question: '-'
      },
      errorMessages: [],
      from: 0,
      until: 2000,
      isVisible: false,
      projectSection: 'projects',
      projectList: [],
      p1Active: false,
      p2Active: false,
      p3Active: false,
      p4Active: false
    }
  },
  computed: {
    isMobile: function () {
      if (this.$data.windowWidth > 900) {
        return false
      } else {
        return true
      }
    },
    ...mapGetters([
      'homeTitleTop', 'homeTitleMid', 'homeTitleBot', 'homeDynamicText1', 'homeDynamicText2', 'homeDynamicText3'
    ])
  },
  methods: {
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    resetForm () {
      this.$data.inquiry.name = ''
      this.$data.inquiry.email = ''
      this.$data.inquiry.phoneNumber = ''
    },
    createInquiry () {
      if (this.validateQuoteForm()) {
        this.$store.dispatch('sendMessage', {
          data: {
            message: this.$data.inquiry
          },
          success: () => {
            this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check')
            this.resetForm()
          },
          fail: () => {
            this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline')
          }
        })
      } else {
        this.toast(this.$data.errorMessages[0], 'error', 'error_outline')
      }
    },
    validateQuoteForm () {
      this.$data.errorMessages = []
      if (this.$data.inquiry.name === null || this.$data.inquiry.name === undefined || this.$data.inquiry.name.trim() === '') {
        this.$data.errorMessages.push('Wajib isi nama')
      }
      if (this.$data.inquiry.phoneNumber === null || this.$data.inquiry.phoneNumber === undefined || this.$data.inquiry.phoneNumber.trim() === '') {
        this.$data.errorMessages.push('Wajib isi nomor telepon')
      }
      if (this.$data.inquiry.email === null || this.$data.inquiry.email === undefined || this.$data.inquiry.email.trim() === '') {
        this.$data.errorMessages.push('Wajib isi email')
      }
      if (this.$data.errorMessages.length > 0) {
        return false
      } else {
        return true
      }
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    },
    formatter: function (num) {
      return num.toFixed(2)
    },
    afterParty () {
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    goToProject () {
      this.$router.push('/projects')
    },
    visibilityChanged1 (isVisible, entry) {
      this.$data.isVisible = isVisible
      this.$refs.num1.start()
    },
    visibilityChanged2 (isVisible, entry) {
      this.$data.isVisible = isVisible
      this.$refs.num2.start()
    },
    visibilityChanged3 (isVisible, entry) {
      this.$data.isVisible = isVisible
      this.$refs.num3.start()
    },
    visibilityChanged4 (isVisible, entry) {
      this.$data.isVisible = isVisible
      this.$refs.num4.start()
    },
    goToProducts () {
      this.$router.push('/products')
    },
    getProjectList () {
      this.$data.isLoading = true
      this.$store.dispatch('getProjectList', {
        // data: {
        //   page: 0,
        //   size: 4
        // },
        success: (res) => {
          this.$data.projectList = res.data
          this.$data.isLoading = false
        },
        fail: () => {
          this.$data.isLoading = false
          this.$data.isError = true
          console.log('failed get project list')
        }
      }).then(() => {
      }).catch(err => {
        console.log('catch in getProjectList ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.getProjectList()
    this.findAllContents()
    // this.findContentById('homeTitleTop')
    // this.findContentById('homeTitleMid')
    // this.findContentById('homeTitleBot')
    // this.findContentById('homeDynamicText1')
    // this.findContentById('homeDynamicText2')
    // this.findContentById('homeDynamicText3')
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  }
}
</script>

<style scoped>
.backgroundImg {
  background-size: cover !important;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.sections {
  padding: 30px;
}
.sections .bcol {
  margin-top: 15px;
  margin-bottom: 15px;
}
.section1 {
  padding-top: 10vh;
  padding-bottom: 10vh;
}
.section1Desktop {
  padding-top: 20vh !important;
  padding-bottom: 20vh !important;
}
.homeIconTitle {
  font-weight: bold;
  font-size: 1.2em;
  margin: 10px 0px;
}
.homeIconTitleDesktop {
  margin: 30px 0px;
  font-size: 2em;
}
.section2 {
  background-color: #f2f2f2;
}
.section2 .preTitle {
  font-weight: bold;
}
.section2 .title {
  max-width: 450px;
  font-size: 2.3em;
  font-weight: bold;
  font-family: Georgia, Times, 'Times New Roman', serif;
  color: #000;
  letter-spacing: 3px;
  margin-bottom: 40px;
}
.quoteForm {
  padding: 40px;
  background-size: cover !important;
}
.formTitle {
  color: #fff;
  font-weight: 900;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 1.4em;
  margin-bottom: 20px;
}
.form div {
  margin-bottom: 10px;
  
}
.form select {
  width: 100%;
}
.form input {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.form button {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 0px;
}
select{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 10px;
}
.primaryBtn {
  background-color: #FF8F00;
  color: #fff;
}
.goToProductsBtn {
  padding: 10px 40px;
  margin-top: 40px;
}
.goToProductsBtn:hover {
  cursor: pointer;
}
.section3 {
  margin: 60px 0px;
}
.anumber {
  font-size: 2em;
  background-color: #FFA000; /*secondary color*/
  padding: 50px 40px;
  border-radius: 50%;
  height: 150px;
  width: 150px;
  color: #fff;
  font-weight: bolder;
}
.anumberText {
  margin-top: 20px;
  font-size: 1.2em;
  font-weight: bolder;
}
.latestProjects {
  background-color: #000;
  color: #fff;
}
.sectionProject {
  position: relative;
  text-align: center;
  font-weight: bolder;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transition: color 300ms ease-in;
  -moz-transition: color 300ms ease-in;
  -o-transition: color 300ms ease-in;
  transition: color 300ms ease-in;
}
.centered button {
  -webkit-transition: background-color 300ms ease-in;
  -moz-transition: background-color 300ms ease-in;
  -o-transition: background-color 300ms ease-in;
  transition: background-color 300ms ease-in;
  outline: none;
  cursor: pointer;
  border: none;
}
.centered button:hover {
  background-color: #000;
  color: #fff;
}
.sectionProject .project {
  max-height: 500px;
}
.img {
  max-height: 100%;
  -webkit-transition: opacity 300ms ease-in;
  -moz-transition: opacity 300ms ease-in;
  -o-transition: opacity 300ms ease-in;
  transition: opacity 300ms ease-in;
}
.project:hover > .img {
  opacity: 0.3;
}

</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue